import { createTheme } from '@mui/material/styles'
import { deepmerge } from '@mui/utils'
import { enUS, frFR } from '@mui/x-data-grid'

import DefaultScreenSizeTheme from 'assets/styles/themes/DefaultScreenSizeTheme'
import ColorsTheme from 'assets/styles/themes/ColorTheme'
import VariantsTheme from 'assets/styles/themes/VariantsTheme'
import { isFrenchLocale } from 'lib/utility/LocaleHelper'
import DefaultPRMGridTheme from 'assets/styles/themes/DefaultPrmGridTheme'
import DefaultGenericTheme from './DefaultGenericTheme'

const locale = isFrenchLocale() ? frFR : enUS

const ColorsVariantsTheme = createTheme(
  deepmerge({ ...ColorsTheme }, { ...VariantsTheme }),
)

export const appTheme = createTheme(
  deepmerge({ ...ColorsVariantsTheme }, { ...DefaultScreenSizeTheme }),
  locale,
)

/**
 * customPrmGridTheme: separate theme which includes the custom styles used in the
 * PRM application
 *
 * prmTheme: Since prmGridTheme acts as a inner theme provider, customisations in the
 * app theme gets lost, hence prmtheme will contain the styles specific to PRM and
 * also customisation which are performed in the app level.
 */
const customPrmGridTheme = createTheme(
  deepmerge({ ...DefaultGenericTheme }, { ...DefaultPRMGridTheme }),
)

export const prmTheme = createTheme(
  deepmerge({ ...customPrmGridTheme }, { ...ColorsVariantsTheme }),
)
